import { observable, action, computed, flow } from 'mobx';
import Serv from './indexServ';

class ActiveAdPopupMod {
  @observable itemInfo = {};

  // 弹框index
  @observable modalIndex = 0;

  @observable popupList = [];

  //
  @observable productInfo = {};

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }
  // 获取移动端活动广告弹窗
  getActiveAdList = flow(function* (params) {
    try {
      const { data } = yield Serv.getActiveAdList(params);
      let _data = data.filter((item) => item.popupRemindType != 4 && item.popupRemindType != 5);
      // console.log('获取移动端活动广告弹窗==', _data);
      this.popupList = _data || [];
      return _data || [];
    } catch (error) {}
  });

  // 保存弹窗显示记录
  savePopupRecord = flow(function* (id) {
    const params = {
      popupId: id
    };
    try {
      const { data } = yield Serv.savePopupRecord(params);
      return data;
    } catch (error) {}
  });

  /**
   * 获取产品详情
   */
  getProductDetail = flow(function* (itemCode) {
    try {
      const { data, resultCode } = yield Serv.getProductDetail(itemCode);
      // console.log('获取产品详情====', data);
      this.productInfo = data || {};
      return data;
    } catch (error) {
      console.log(error, '---error wechat login--->');
    }
  });
}
const activeAdPopupMod = new ActiveAdPopupMod();
export default activeAdPopupMod;



// WEBPACK FOOTER //
// ./src/pubBiz/ActiveAdPopup/indexMod.js